module.exports = __webpack_public_path__ + "img/UZ.a0eae908.svg";